import * as lc from '../../../../../utils/lodashCustom';
import { getValueFromRefDataModules } from '../../../../main/reducers/static/states/referenceLists/reducer';

export default null;
export function restructureTasksByExecutorResponseModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    desc: lc.get(data, 'desc'),
    check_desc: lc.get(data, 'check_desc'),
    base_link: lc.get(data, 'base_link'),
    type_id: lc.get(data, 'type_id'),
    task_type_desc: getValueFromRefDataModules(state, 'tasks.taskTypes').find(
      item => item.value === lc.get(data, 'type_id')
    ).title,
    check_type_desc: lc.get(data, 'check_type_desc'),
    executor_execution_interval_desc: lc.get(
      data,
      'executor_execution_interval_desc'
    ),
    time_perform_desc: lc.get(data, 'time_perform_desc'),
    has_time_target: lc.get(data, 'has_time_target'),
    has_geo_target: lc.get(data, 'has_geo_target'),
    adult_content: lc.get(data, 'adult_content'),
    software_install: lc.get(data, 'software_install'),
    has_mark_hide: lc.get(data, 'has_mark_hide'),
    has_mark_chosen: lc.get(data, 'has_mark_chosen'),
    reasons_locked_for_execution: lc.get(data, 'reasons_locked_for_execution'),
    cost: lc.get(data, 'cost'),
    is_pinned: lc.get(data, 'is_pinned'),
    is_pinned_by_category: lc.get(data, 'is_pinned_by_category'),
    is_highlighted: lc.get(data, 'is_highlighted'),
    owner: {
      id: lc.get(data.owner, 'id'),
      username: lc.get(data.owner, 'username'),
      status: lc.get(data.owner, 'status'),
      avatarUrl: lc.get(data.owner, 'avatarUrl')
    },
    task_stat: {
      task_id: lc.get(data.task_stat, 'task_id'),
      task_earned_funds: lc.get(data.task_stat, 'task_earned_funds'),
      task_spent_funds: lc.get(data.task_stat, 'task_spent_funds'),
      task_reserved_funds: lc.get(data.task_stat, 'task_reserved_funds'),
      task_possible_refund: lc.get(data.task_stat, 'task_possible_refund'),
      exec_reserved_count: lc.get(data.task_stat, 'exec_reserved_count'),
      exec_status_processed_count: lc.get(
        data.task_stat,
        'exec_status_processed_count'
      ),
      exec_status_at_checkout_count: lc.get(
        data.task_stat,
        'exec_status_at_checkout_count'
      ),
      exec_status_remake_count: lc.get(
        data.task_stat,
        'exec_status_remake_count'
      ),
      exec_status_finished_count: lc.get(
        data.task_stat,
        'exec_status_finished_count'
      ),
      exec_status_not_done_count: lc.get(
        data.task_stat,
        'exec_status_not_done_count'
      ),
      exec_status_canceled_count: lc.get(
        data.task_stat,
        'exec_status_canceled_count'
      ),
      exec_status_dispute_count: lc.get(
        data.task_stat,
        'exec_status_dispute_count'
      ),
      exec_status_canceled_by_task_owner_count: lc.get(
        data.task_stat,
        'exec_status_canceled_by_task_owner_count'
      ),
      exec_total_count: lc.get(data.task_stat, 'exec_total_count'),
      exec_disputes_win_count: lc.get(
        data.task_stat,
        'exec_disputes_win_count'
      ),
      exec_disputes_lost_count: lc.get(
        data.task_stat,
        'exec_disputes_lost_count'
      ),
      exec_disputes_count: lc.get(data.task_stat, 'exec_disputes_count'),
      comment_likes_count: lc.get(data.task_stat, 'comment_likes_count'),
      comment_dislikes_count: lc.get(data.task_stat, 'comment_dislikes_count'),
      comment_neutral_count: lc.get(data.task_stat, 'comment_neutral_count'),
      comment_total_count: lc.get(data.task_stat, 'comment_total_count'),
      updated_at: lc.get(data.task_stat, 'updated_at')
    },
    created_at: lc.get(data, 'created_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksPublicService/restructuring/index.js